import { render, staticRenderFns } from "./automatic_invitation.vue?vue&type=template&id=0daeeebc&scoped=true"
import script from "./automatic_invitation.vue?vue&type=script&lang=js"
export * from "./automatic_invitation.vue?vue&type=script&lang=js"
import style0 from "./automatic_invitation.vue?vue&type=style&index=0&id=0daeeebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daeeebc",
  null
  
)

export default component.exports